import { atom } from "jotai";
import type { StopFindResult } from "../api/stopFind";

export const stopDetailsCacheAtom = atom(
  new Map<string, StopFindResult | null>()
);

export const stopDetailsInflightAtom = atom(
  new Map<string, Promise<StopFindResult | null>>()
);
